/// <reference types="./getSpecification.d.ts" />
import { ok, } from '@dossierhq/core';
import { queryNoneOrOne } from '../QueryFunctions.js';
export async function schemaGetSpecification(database, context) {
    const result = await queryNoneOrOne(database, context, 'SELECT version, specification FROM schema_versions ORDER BY version DESC LIMIT 1');
    if (result.isError())
        return result;
    if (result.value) {
        const { version, specification } = result.value;
        return ok({ ...JSON.parse(specification), version });
    }
    return ok(null);
}
//# sourceMappingURL=getSpecification.js.map